import React from 'react';
import { createGlobalStyle as css } from 'styled-components';
import { useLocale } from './hooks/useLocale';

const CyrillicFonts = css`
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: normal;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: bold;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: 800;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
  /* font-family override */
  body {
    font-family: 'Maax', 'spotify-circular-cyrillic', sans-serif;
  }
`;

// Vietnamese override to avoid mixed characters issue: https://anchorfm.atlassian.net/browse/CAST-2799
const VietnameseOverride = css`
  body {
    font-family: sans-serif;
  }
`;

export function I18nFonts() {
  const { locale } = useLocale();
  return (
    <>
      {['ru', 'bg'].includes(locale) && <CyrillicFonts />}
      {locale === 'vi' && <VietnameseOverride />}
    </>
  );
}
